import { AlpineComponent } from '@alpinejs/csp';
import Lottie from 'lottie-web';
import { lerp } from '../../javascripts/helpers/maths';

const Stage = (): AlpineComponent => ({
  visible: false,
  lottie: undefined,

  maxScale: 1,
  maxHeight: 0,
  init() {
    this.lottie = Lottie.loadAnimation({
      container: this.$refs.animation,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: '/dist/assets/animations/arrow-desktop.json',
      rendererSettings: {
        viewBoxOnly: true
      }
    });

    const headlineRect = this.$refs.headline.getBoundingClientRect();
    const left = (640 - headlineRect.left) * -1;
    this.$refs.animation.style.left = `${left}px`;

    this.handleResize();
  },

  getClassName() {
    return this.visible ? 'stage--visible' : '';
  },

  handleScroll() {
    if (!this.$refs.image) return;

    const currentScroll = window.scrollY;
    const { top } = this.$refs.image.getBoundingClientRect();

    const maxScroll = top + window.scrollY;
    const minScroll = 0;

    let percentage = (currentScroll - minScroll) / maxScroll;
    if (window.scrollY > maxScroll) percentage = 1;
    if (percentage < 0) percentage = 0;

    const t = percentage > 1 ? 1 : percentage;
    const scale = lerp(1, this.maxScale, t);
    const radius = Math.floor(lerp(20, 0, t));

    this.$refs.image.setAttribute(
      'style',
      `--scale-factor: ${scale}; --border-radius: ${radius}px; height: ${this.maxHeight}px`
    );
  },

  handleResize() {
    if (!this.$refs.image) return;

    const { width } = this.$refs.image.getBoundingClientRect();
    const maxImageWidth = window.innerWidth > 1396 ? 1396 : window.innerWidth;
    const ratio = window.innerWidth >= 768 ? 1 / 2 : 3 / 4;
    this.maxScale = maxImageWidth / width;
    this.maxHeight = width * this.maxScale * ratio;

    this.handleScroll();
  },
  handleIntersect() {
    this.lottie.play();
    this.visible = true;
  }
});

export default Stage;
